import React from 'react';
import { Modal } from '@everlywell/leaves';

import { generateKey } from 'utils/helpers';

import * as S from './styles';

export type Item = {
  image: string;
  title: string;
  items: string[];
};

type Props = {
  openHandler: (x: boolean) => void;
  open: boolean;
  modalTitle: string;
  listOfItems: Item[];
};

export const MeasuredItems = ({ listOfItems }: Pick<Props, 'listOfItems'>) => (
  <>
    {listOfItems?.map(item => {
      return (
        <S.MarkerContainer key={generateKey()}>
          <S.MarkerTitleContainer>
            <S.MarkerIcon aria-hidden="true" src={item.image} />
            <S.MarkerTitle>
              {item.title} ({item.items.length})
            </S.MarkerTitle>
          </S.MarkerTitleContainer>
          <S.MarkerList>
            {item.items.map(marker => (
              <S.Marker key={generateKey()}>{marker}</S.Marker>
            ))}
          </S.MarkerList>
        </S.MarkerContainer>
      );
    })}
  </>
);

export const MeasuredItemsModal = ({
  modalTitle,
  listOfItems,
  open,
  openHandler,
}: Props) => {
  return open ? (
    <Modal open={open} openHandler={openHandler}>
      <S.MarkerModalTitle>{modalTitle}</S.MarkerModalTitle>
      <MeasuredItems listOfItems={listOfItems} />
    </Modal>
  ) : null;
};

export default MeasuredItemsModal;
